/**
 * Determina si el registro de inspección fue editado después de crearse: ambas marcas de tiempo existen y no coinciden.
 */
export const hasToolInspectionBeenEdited = (
  createdAt?: string | null,
  updatedAt?: string | null
): boolean => Boolean(createdAt && updatedAt && createdAt !== updatedAt);

/**
 * Construye la URL de redirección para la creación de un DSN en el sitio de WMS.
 * @param logisticServiceId - El ID de la logistic service.
 * @param logisticServiceProductId - El ID del producto de la logistic service.
 * @returns La URL de redirección para la creación de un DSN en el sitio de WMS.
 */
export const getCreateDSNSiteUrl = (
  logisticServiceId?: number | null,
  logisticServiceProductId?: number | null
): string | null => {
  if (!logisticServiceId || !logisticServiceProductId) return null;

  const createDSNSiteBaseUrl = process.env.REACT_APP_WMS;
  const mySiteBaseUrl = window.location.origin;

  const returnUrl = `${mySiteBaseUrl}/logistic-service/details/${logisticServiceId}`;

  try {
    const targetPath = `${createDSNSiteBaseUrl}/tool-inspection/create-inspection/${logisticServiceProductId}`;
    const targetUrl = new URL(targetPath);
    targetUrl.searchParams.append('redirectUrl', returnUrl);

    return targetUrl.toString();
  } catch (error) {
    console.error('Error al construir la URL de redirección:', error);
    return null;
  }
};
